/**
 * CORE-1483 — соцсети Agapella для подвала.
 *
 * Список и адреса — из редакции Маши «Футер 21.09», состав подтверждён
 * Вероникой 04.10.2026: пять сетей, X убран. Адрес Telegram составлен из
 * указанного `@agapellaworld` — его велено проверить перед релизом.
 *
 * Одно место на все поверхности: кто рисует иконки, тот берёт их отсюда, а
 * не держит адреса в разметке.
 */
export type SocialNetworkId = 'instagram' | 'telegram' | 'vk' | 'dzen' | 'youtube';

export interface SocialLink {
  id: SocialNetworkId;
  /** Как сеть называется у человека — идёт в подпись для читалки. */
  label: string;
  url: string;
}

export const SOCIAL_LINKS: readonly SocialLink[] = [
  { id: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/agapellaworld' },
  { id: 'telegram', label: 'Telegram', url: 'https://t.me/agapellaworld' },
  { id: 'vk', label: 'VK', url: 'https://vk.ru/agapellaworld' },
  { id: 'dzen', label: 'Дзен', url: 'https://dzen.ru/agapellaworld' },
  { id: 'youtube', label: 'YouTube', url: 'https://www.youtube.com/@agapellaworld' },
];

/**
 * CORE-1768 — сети, которые подвал не показывает никому: ни по стране, ни по
 * IP — с VPN региональное скрытие (CORE-107) не держится. Решение Вероники
 * 19.10.2026. Адрес сети остаётся в `SOCIAL_LINKS`: вернуть её — флаг, а не
 * правка.
 *
 * Новая сеть сюда — только по продуктовому решению; компоненты подвала об
 * этом списке не знают, они зовут `visibleFooterSocials`.
 */
export const FOOTER_HIDDEN_SOCIALS: readonly SocialNetworkId[] = ['instagram'];

/**
 * Серверный флаг, который ВОЗВРАЩАЕТ скрытые сети. Назван «показать», а не
 * «скрыть» нарочно: флага нет в базе или `/api/features` ещё не ответил —
 * значит выключен, и сеть скрыта без мигания при загрузке.
 */
export const FOOTER_HIDDEN_SOCIALS_SHOWN_FLAG = 'footer_hidden_socials_shown';

export function visibleFooterSocials<T extends { id?: SocialNetworkId }>(
  items: readonly T[],
  hiddenShown: boolean,
): T[] {
  if (hiddenShown) return [...items];
  return items.filter((item) => !item.id || !FOOTER_HIDDEN_SOCIALS.includes(item.id));
}
